import {
  EventNames,
  EventParameters,
} from './genericEvents';

// To see more, such as typical parameters used for events, see
// https://support.google.com/analytics/answer/9267735?hl=en&ref_topic=13367566&sjid=11576371771888822611-EU and
// https://support.google.com/analytics/answer/9234069?hl=en&ref_topic=13367566&sjid=11576371771888822611-EU
export const FirebaseCommonEventNames = {
  [EventNames.AchievementUnlocked]: 'unlock_achievement',
  [EventNames.AddPaymentInformation]: 'add_payment_info',
  [EventNames.AddShippingInformation]: 'add_shipping_info',
  [EventNames.AddToCart]: 'add_to_cart',
  [EventNames.AddToWishlist]: 'add_to_wishlist',
  [EventNames.Checkout]: 'begin_checkout',
  [EventNames.CustomerApplication]: 'generate_lead',
  [EventNames.CustomerApplicationFailed]: 'close_unconvert_lead',
  [EventNames.CustomerApplicationSuccessful]: 'close_convert_lead',
  [EventNames.CustomerDisqualification]: 'disqualify_lead',
  [EventNames.CustomerQualification]: 'qualify_lead',
  [EventNames.CustomerRepresentativeContact]: 'working_lead',
  [EventNames.EarnVirtualCurrency]: 'earn_virtual_currency',
  [EventNames.JoinGroup]: 'join_group',
  [EventNames.LevelEnd]: 'level_end',
  [EventNames.LevelStart]: 'level_start',
  [EventNames.LevelUp]: 'level_up',
  [EventNames.ListView]: 'view_item_list',
  [EventNames.Login]: 'login',
  [EventNames.PostScore]: 'post_score',
  [EventNames.Purchase]: 'purchase',
  [EventNames.Refund]: 'refund',
  [EventNames.Register]: 'sign_up',
  [EventNames.RemoveFromCart]: 'remove_from_cart',
  [EventNames.Search]: 'search',
  [EventNames.SelectContent]: 'select_content',
  [EventNames.SelectPromotion]: 'select_promotion',
  [EventNames.SessionStart]: 'session_start',
  [EventNames.Share]: 'share',
  [EventNames.SpendVirtualCurrency]: 'spend_virtual_currency',
  [EventNames.TutorialComplete]: 'tutorial_complete',
  [EventNames.TutorialStart]: 'tutorial_begin',
  [EventNames.UserEngagement]: 'user_engagement',
  [EventNames.ViewCart]: 'view_cart',
  [EventNames.ViewItem]: 'view_item',
  [EventNames.ViewPromotion]: 'view_promotion',
  [EventNames.Visit]: 'first_visit',
};

// To see more, such as the descriptions of parameters, see https://support.google.com/analytics/table/13594742?hl=en&ref_topic=13367566&sjid=11576371771888822611-EU
export const FirebaseEventParameters = {
  [EventParameters.AchievementId]: 'achievement_id',
  [EventParameters.AdExposureTime]: 'exposure_time',
  [EventParameters.AdFormat]: 'ad_format',
  [EventParameters.AdId]: 'ad_event_id',
  [EventParameters.AdPlatform]: 'ad_platform',
  [EventParameters.AdSource]: 'ad_source',
  [EventParameters.AdUnitCode]: 'ad_unit_code',
  [EventParameters.AdUnitId]: 'ad_unit_id',
  [EventParameters.AdUnitName]: 'ad_unit_name',
  [EventParameters.AppVersion]: 'app_version',
  [EventParameters.Campaign]: 'campaign',
  [EventParameters.CampaignAnid]: 'anid',
  [EventParameters.CampaignClickId]: 'aclid',
  [EventParameters.CampaignContent]: 'campaign_content',
  [EventParameters.CampaignDetailsContent]: 'content',
  [EventParameters.CampaignDetailsSource]: 'source',
  [EventParameters.CampaignDetailsTerm]: 'term',
  [EventParameters.CampaignInformationSource]: 'campaign_info_source',
  [EventParameters.CampaignMedium]: 'campaign_medium',
  [EventParameters.CampaignSource]: 'campaign_source',
  [EventParameters.CampaignTerm]: 'campaign_term',
  [EventParameters.CancellationReason]: 'cancellation_reason',
  [EventParameters.ClickTimestamp]: 'click_timestamp',
  [EventParameters.ClientId]: 'client_id',
  [EventParameters.ContentGroup]: 'content_group',
  [EventParameters.ContentId]: 'content_id',
  [EventParameters.ContentType]: 'content_type',
  [EventParameters.Coupon]: 'coupon',
  [EventParameters.CreativeName]: 'creative_name',
  [EventParameters.CreativeSlotName]: 'creative_slot',
  [EventParameters.CurrencyCode]: 'currency',
  [EventParameters.CustomCampaignParameter]: 'cp1',
  [EventParameters.DeferredAnalyticsCollection]: 'deferred_analytics_collection',
  [EventParameters.DiscountAmount]: 'discount',
  [EventParameters.DynamicLinkAcceptanceTime]: 'accept_time',
  [EventParameters.EngagementTime]: 'engagement_time_msec',
  [EventParameters.FileExtension]: 'file_extension',
  [EventParameters.FileLinkText]: 'link_text',
  [EventParameters.FileName]: 'file_name',
  [EventParameters.FirstOpenCount]: 'previous_first_open_count',
  [EventParameters.FirstOpenWithAnalytics]: 'updated_with_analytics',
  [EventParameters.FormId]: 'form_id',
  [EventParameters.FormName]: 'form_name',
  [EventParameters.FormSubmissionLink]: 'form_destination',
  [EventParameters.FormSubmitText]: 'form_submit_text',
  [EventParameters.GameCharacterLevel]: 'level',
  [EventParameters.GameCharacterName]: 'character',
  [EventParameters.GameLevelName]: 'level_name',
  [EventParameters.GameScore]: 'score',
  [EventParameters.GoogleClickId]: 'gclid',
  [EventParameters.GroupId]: 'group_id',
  [EventParameters.IgnoreReferrer]: 'ignore_referrer',
  [EventParameters.Index]: 'index',
  [EventParameters.IntroductoryPrice]: 'introductory_price',
  [EventParameters.IsEmbeddedVideoVisible]: 'visible',
  [EventParameters.IsFatalError]: 'fatal',
  [EventParameters.IsFreeTrial]: 'free_trial',
  [EventParameters.IsOutboundLink]: 'outbound',
  [EventParameters.IsSubscriptionPurchase]: 'subscription',
  [EventParameters.IsSystemAppOpen]: 'system_app',
  [EventParameters.IsSystemAppUpdate]: 'system_app_update',
  [EventParameters.ItemBrand]: 'item_brand',
  [EventParameters.ItemCategory]: 'item_category',
  [EventParameters.ItemId]: 'item_id',
  [EventParameters.ItemListId]: 'item_list_id',
  [EventParameters.ItemListName]: 'item_list_name',
  [EventParameters.ItemLocationId]: 'location_id',
  [EventParameters.ItemName]: 'item_name',
  [EventParameters.ItemSubCategoryFour]: 'item_category5',
  [EventParameters.ItemSubCategoryOne]: 'item_category2',
  [EventParameters.ItemSubCategoryThree]: 'item_category4',
  [EventParameters.ItemSubCategoryTwo]: 'item_category3',
  [EventParameters.ItemVariant]: 'item_variant',
  [EventParameters.LinkClasses]: 'link_classes',
  [EventParameters.LinkDomain]: 'link_domain',
  [EventParameters.LinkId]: 'link_id',
  [EventParameters.LinkUrl]: 'link_url',
  [EventParameters.Medium]: 'medium',
  [EventParameters.MessageDeliveryTimestamp]: 'message_device_timestamp',
  [EventParameters.MessageId]: 'message_id',
  [EventParameters.MessageTimestamp]: 'message_time',
  [EventParameters.MessageTitle]: 'message_name',
  [EventParameters.MessageType]: 'message_type',
  [EventParameters.NotificationChannel]: 'message_channel',
  [EventParameters.NotificationLabel]: 'label',
  [EventParameters.NotificationTopic]: 'topic',
  [EventParameters.PageLocation]: 'page_location',
  [EventParameters.PageTitle]: 'page_title',
  [EventParameters.PercentScrolled]: 'percent_scrolled',
  [EventParameters.PreviousAppVersion]: 'previous_app_version',
  [EventParameters.PreviousGMPAppId]: 'previous_gmp_app_id',
  [EventParameters.PreviousOsVersion]: 'previous_os_version',
  [EventParameters.PreviousLink]: 'page_referrer',
  [EventParameters.Price]: 'price',
  [EventParameters.ProductAffiliation]: 'affiliation',
  [EventParameters.ProductId]: 'product_id',
  [EventParameters.PromotionId]: 'promotion_id',
  [EventParameters.PromotionName]: 'promotion_name',
  [EventParameters.Quantity]: 'quantity',
  [EventParameters.ResetAnalyticsCause]: 'reset_analytics_cause',
  [EventParameters.RewardType]: 'reward_type',
  [EventParameters.RewardValue]: 'reward_value',
  [EventParameters.ScreenResolution]: 'screen_resolution',
  [EventParameters.SearchTerm]: 'search_term',
  [EventParameters.SessionId]: 'ga_session_id',
  [EventParameters.SessionNumber]: 'ga_session_number',
  [EventParameters.ShippingCost]: 'shipping',
  [EventParameters.ShippingTier]: 'shipping_tier',
  [EventParameters.Success]: 'success',
  [EventParameters.TaxAmount]: 'tax',
  [EventParameters.Timestamp]: 'timestamp',
  [EventParameters.TrafficType]: 'traffic_type',
  [EventParameters.TransactionId]: 'transaction_id',
  [EventParameters.Value]: 'value',
  [EventParameters.VideoCurrentTime]: 'video_current_time',
  [EventParameters.VideoDuration]: 'video_duration',
  [EventParameters.VideoPercent]: 'video_percent',
  [EventParameters.VideoProvider]: 'video_provider',
  [EventParameters.VideoTitle]: 'video_title',
  [EventParameters.VideoLink]: 'video_url',
  [EventParameters.VirtualCurrencyName]: 'virtual_currency_name',
};